import { useOwnTranslate } from 'lib/hooks/useOwnTranslate';
import useHPIDetail from '../hooks/useHPIDetail';
import HousePricesTrendsChart from './housePricesTrendsChart';
import HousePricesTrendsData from './housePricesTrendsData';
import HousePricesTrendsOptions from './housePricesTrendsOptions';


export interface Location {
  id?: number;
  type?: string;
}

const HousePricesTrends = ({ id, type }: Location) => {
  const { housePricesTrendsOptions, chartData, marketStats, mode } = useHPIDetail({
    city: type === 'CITY' ? id : undefined,
    region: type === 'REGION' ? id : undefined,
  });
  const { t } = useOwnTranslate('plp.propertyInfo');
  let hasMarketStats: boolean = false;

  if (marketStats !== undefined && marketStats?.length > 0) {
    marketStats.forEach(item => {
      if (item.content.length) {
        hasMarketStats = true;
        return;
      }
    });
  }

  return (

    <section className='mt-12'>
      <h2 className='lg:text-display-sm text-display-xs font-semiBold lg:mb-6 mb-4'>
        {t('marketInfo')}
      </h2>

      {(
        (chartData !== undefined && chartData?.length > 0) ||
        (hasMarketStats)
      ) ? (
        <div
          className='grid grid-cols-4 gap-4 p-4 border rounded-md shadow-sm border-grey-200 lg:p-6 lg:px-4 lg:grid-cols-12 lg:gap-8'>
          <div className='flex flex-col items-start gap-5 lg:col-span-9 col-span-full'>
            <HousePricesTrendsOptions {...housePricesTrendsOptions} />
            <HousePricesTrendsChart
              mode={mode}
              chartData={chartData!}
            />
          </div>
          <div className='flex flex-col items-start gap-5 lg:col-span-3 col-span-full'>
            <HousePricesTrendsData stats={marketStats!} />
          </div>
        </div>
      ) : (
        <div className='font-bold items-center'>
          <p className='text-center'>در حال حاضر داده ای برای نمایش وجود ندارد</p>
        </div>
      )}
    </section>
  );
};

export default HousePricesTrends;
